var _path, _rect, _path2, _rect2, _circle, _circle2, _circle3, _path3, _circle4, _circle5, _circle6, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisuelPoints(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 282,
    viewBox: "0 0 171 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H171V282H3C1.34314 282 0 280.657 0 279V3Z",
    fill: "#4F0DBC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 171,
    height: 139,
    transform: "translate(0 143)",
    fill: "url(#paint0_linear_3189_260709)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171 146H74H0L0 45.3385C19.249 36.7652 40.568 32 63 32C104.993 32 143.086 48.6995 171 75.8198V146Z",
    fill: "#6725D2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 97,
    width: 92,
    height: 92,
    rx: 30,
    stroke: "#8B57DF",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 108,
    r: 35,
    fill: "#6725D2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 51,
    cy: 108,
    r: 35,
    fill: "#8B57DF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 108,
    r: 33,
    stroke: "#BA8BEA",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.25 119.375C46.8575 119.375 43.06 116.89 41.17 113.25H51.25V109.75H40.015C39.9275 109.173 39.875 108.595 39.875 108C39.875 107.405 39.9275 106.828 40.015 106.25H51.25V102.75H41.17C43.06 99.11 46.875 96.625 51.25 96.625C54.0675 96.625 56.6575 97.6575 58.6525 99.3725L61.75 96.275C58.9675 93.7725 55.275 92.25 51.25 92.25C44.39 92.25 38.58 96.6425 36.41 102.75H30.25V106.25H35.605C35.535 106.828 35.5 107.405 35.5 108C35.5 108.595 35.535 109.173 35.605 109.75H30.25V113.25H36.41C38.58 119.358 44.39 123.75 51.25 123.75C55.2925 123.75 58.9675 122.228 61.75 119.725L58.635 116.628C56.6575 118.343 54.085 119.375 51.25 119.375Z",
    fill: "#BA8BEA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 178,
    r: 35,
    fill: "#6725D2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 121,
    cy: 178,
    r: 33,
    fill: "#8B57DF",
    stroke: "#8B57DF",
    strokeWidth: 4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 178,
    r: 33,
    stroke: "#BA8BEA",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.983 160.5C111.322 160.5 103.5 168.34 103.5 178C103.5 187.66 111.322 195.5 120.983 195.5C130.66 195.5 138.5 187.66 138.5 178C138.5 168.34 130.66 160.5 120.983 160.5ZM128.403 188.5L121 184.038L113.597 188.5L115.558 180.082L109.03 174.43L117.64 173.695L121 165.75L124.36 173.677L132.97 174.412L126.442 180.065L128.403 188.5Z",
    fill: "#BA8BEA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3189_260709",
    x1: 85.5,
    y1: 0,
    x2: 85.5,
    y2: 139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6725D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6725D2",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisuelPoints);
export default __webpack_public_path__ + "static/media/visuel_points.3e36bd6566cb63ffe3bab683a322d6e6.svg";
export { ForwardRef as ReactComponent };